import userSessionStorage from '@/context/userSessionStorage'
import { useEffect, useState } from 'react'

export default function useUserLogged() {
  const [logged, setLogged] = useState(false)
  const revalidate = () => {
    userSessionStorage.validateLogged().then(logged => {
      setLogged(logged ? true : false)
    })
  }
  useEffect(() => {
    revalidate()
    window.addEventListener('storage', revalidate)
    return () => {
      window.removeEventListener('storage', revalidate)
    }
  }, [])
  return [logged, revalidate]
}
